import React, { useState, useEffect, useRef } from "react";
import {
  Calendar,
  Badge,
  CustomProvider,
  SelectPicker,
  HStack,
  Panel,
  toaster,
  Message,
  Text,
  Modal,
  Drawer,
  Highlight,
  Popover,
  Whisper,
  Tag,
  Textarea,
} from "rsuite";
import { Button, Card, Table, Space, Input, notification } from "antd";
import { LayoutHome } from "./LayoutHome";
import es_ES from "rsuite/locales/es_ES";
import "../Styles/style-CitasMed.css";
import moment from "moment/moment";
import Highlighter from "react-highlight-words";
import "moment/locale/es"; // Importante para el idioma español
import { phoneNumberAutoFormat, calculaEdad } from "../Utils";
import {
  getCitasMedico,
  getDatosCitaMedico,
  saveCitaMedico,
} from "./Services/AgendaCitas";
import { getMedicosServicio } from "./Services/CatalogosServices";
import { getCatServicios } from "./Services/HorariosServices";
import {
  getListaPacientes,
  getTelefonoXID,
  saveCancelCitaMedico,
} from "./Services/ConsultasServices";
import {
  FaBackward,
  FaCheck,
  FaDoorOpen,
  FaFastForward,
  FaFileMedical,
  FaSave,
  FaSearch,
  FaTrash,
} from "react-icons/fa";
import { SearchOutlined } from "@ant-design/icons";

export const CitasMedicas = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedicoSesion] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const [medico] = useState(JSON.parse(localStorage.getItem("auth")).medico);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [estatusCita, setEstatusCita] = useState("");
  const [listMedicos, setListMedicos] = useState([]);
  const [listServicios, setListServicios] = useState([]);
  const [showListaPac, setSowListaPac] = useState(true);
  const [nuevoPac, setNuevoPac] = useState(false);
  const [idMedico, setIdMedico] = useState("0");
  const [idServicio, setIdServicio] = useState("0");
  const [openCancel, setOpenCancel] = useState(false);
  const [motivoCancel, setMotivoCancel] = useState("");
  const [btnCancel, setBtnCancel] = useState(false);
  const [dataCancel, setDataCancel] = useState("");
  const [dataFiltros] = useState([
    { label: "Todos", value: "Todos" },
    { label: "Citas Pendientes", value: "red" },
    { label: "Citas Realizadas", value: "blue" },
    { label: "Horarios Disponibles", value: "green" },
  ]);
  const [filtroCitas, setFiltroCitas] = useState("red");
  const [tipoHorario, setTipoHorario] = useState("");
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [mes, setMes] = useState(0);
  const [anio, setAnio] = useState(0);

  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [telefono, setTelefono] = useState("");
  const [atencion, setAtencion] = useState("");
  const [fecNac, setFecNac] = useState("");
  const [edad, setEdad] = useState(0);
  const [domicilio, setDomicilio] = useState("");
  const [contacto1, setContacto1] = useState("");
  const [tel1, setTel1] = useState("");
  const [parentesco1, setParentesco1] = useState("");

  const [disableBtn, setDisableBtn] = useState(true);
  const [openHor, setOpenHor] = useState(false);
  const [dataEdit, setDataEdit] = useState("");
  const [listaPacientes, setListaPacientes] = useState([]);
  const [fechaHorario, setFechaHorario] = useState("");
  const [horario, setHorario] = useState("");
  const [nuevaCita, setNuevaCita] = useState(false);
  const [horaIni, setHoraIni] = useState("");
  const [openModalCitasProg, setOpenModalCitasProg] = useState(false);
  const handleCloseHorario = () => {
    setOpenHor(false);
  };
  const closeModalCitasProg = () => {
    setOpenModalCitasProg(false);
  };
  const handleCloseCancel = () => {
    setOpenCancel(false);
  };

  const [api, contextHolder] = notification.useNotification();
  const [modalDatosPac, setModalDatosPac] = useState(false);

  const [listEstatus, setListEstatus] = useState([
    {
      label: "TODOS",
      value: "TODOS",
    },
  ]);
  const [fecha, setFecha] = useState(new Date().toISOString());
  const [eventData, setEventData] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [data, setData] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const getEstatusCita = (estatus) => {
    let result = "";
    switch (estatus) {
      case "blue":
        result = <Tag color="blue">Realizada</Tag>;
        break;
      case "red":
        result = <Tag color="orange">Pendiente</Tag>;
        break;
      default:
        result = <Tag color="green">Disponible</Tag>;
        break;
    }
    return result;
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "date",
      width: "20%",
      key: "date",
      ...getColumnSearchProps("date"),
      sorter: (a, b) => a.date.length - b.date.length,
      render: (text) => moment(text).format("dddd, DD/MMMM/YYYY"),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Horario",
      dataIndex: "horario",
      key: "horario",
      width: "10%",
      ...getColumnSearchProps("horario"),
      align: "center",
    },
    {
      title: "Estatus",
      dataIndex: "tipo",
      key: "tipo",
      with: "20%",
      align: "center",
      render: (text) => getEstatusCita(text),
    },
    {
      title: "Nombre del paciente",
      dataIndex: "paciente",
      key: "paciente",
      width: "45%",
      sorter: (a, b) => a.paciente.length - b.paciente.length,
      ...getColumnSearchProps("paciente"),
    },
    {
      title: "Acción",
      dataIndex: "",
      key: "x",
      width: "5%",
      render: (text, record) => (
        <Button
          onClick={async () =>
            handleNewCita({
              idPac: record.idPac,
              fecha: moment(record.date).format("YYYY-MM-DD"),
              horario: record.horario,
              paciente: record.paciente,
              estatus: record.tipo,
              opcion: "horarioDisp",
            })
          }
          icon={<FaSearch></FaSearch>}
        ></Button>
      ),
    },
  ];

  const initialized = useRef(false);

  const loadMedicos = async (e) => {
    setIdServicio(e);
    await getMedicosServicio(idNegocio, e, idMedicoSesion).then((res) => {
      setListMedicos(res);
    });
  };

  const loadServicios = async () => {
    await getCatServicios(idNegocio)
      .then(async (res) => {
        const _res = res.filter((itm) => itm.value !== "1");
        setListServicios(_res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadAgenda = async (e) => {
    setIdMedico(e);
    await getCitasMedico(idNegocio, idServicio, e, mes, anio).then(
      async (res) => {
        setEventData(res);
        await loadCitasProgramadas(e);
      },
    );
  };

  const loadCitasProgramadas = async (idMed, idFiltro) => {
    const _filtro = !idFiltro ? filtroCitas : idFiltro;
    setData([]);
    await getCitasMedico(idNegocio, idServicio, idMed, mes, anio).then(
      (res) => {
        const _data = res.filter((ev) => ev.tipo === _filtro);
        setData(_data);

        setTimeout(() => {
          setOpenModalCitasProg(true);
        }, 500);
      },
    );
  };

  const hanldeNombrePaciente = async (e) => {
    if (!e) {
      setTelefono("");
      return;
    }
    if (e === "0") {
      setSowListaPac(false);
      setNuevaCita(true);
      setNuevoPac(true);
      return;
    }

    setIdPaciente(e);

    const res = await getTelefonoXID(idNegocio, e);
    if (!res) {
      setTelefono("");
    }
    if (res.telefono === undefined) {
      return;
    }

    setTelefono(res.telefono);
  };

  const loadDatosCita = async (idPac, fecha) => {
    setIdPaciente(idPac);
    await getDatosCitaMedico(
      idNegocio,
      idPac,
      fecha,
      horaIni,
      idMedico,
      idServicio,
    ).then((res) => {
      setAtencion(res.atencion);
      setPaciente(res.nombre);
      setFecNac(res.fecNac);
      setEdad(calculaEdad(res.fecNac));
      setDomicilio(res.domicilio);
      setTelefono(phoneNumberAutoFormat(res.telefono));
      setContacto1(res.nomContacto1);
      setParentesco1(res.relacion1);
      setTel1(phoneNumberAutoFormat(res.telContac1));
      setModalDatosPac(true);
    });
  };

  const cancelarCita = async () => {
    const datos = {
      id: idNegocio,
      idServicio: idServicio,
      idMedico: idMedico,
      espacio: 1,
      fecha: fecha,
      hora: horaIni,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      toast("Debes escribir un motivo antes de guardar", "warning");
      return;
    }

    const res = await saveCancelCitaMedico(datos);

    if (res.data === -1) {
      toast(
        "No se ha cancelado la cita, porque ya se registro la consulta.",
        "warning",
      );
      return;
    }
    if (res.data === 0) {
      toast("No se ha cancelado la cita, intente nuevamente.", "warning");
      return;
    } else {
      toast("La cita se ha cancelado de forma correcta.", "success");
      setOpenCancel(false);
      setModalDatosPac(false);
      loadAgenda(idMedico);
    }
  };

  const handleSelect = (date) => {
    setFecha(date);
    setSelectedDate(date);
  };

  const handleNewCita = async (props) => {
    console.log(props.fecha);
    setListaPacientes([]);
    setSelectedDate(props.fecha);
    setIdPaciente(props.idPac);
    setEstatusCita(props.estatus);

    var fec = moment(new Date(props.fecha)).format("DD/MM/YYYY");
    setDataEdit(`${fec}`);
    setHorario(props.hora);
    setPaciente(props.paciente);
    setHoraIni(props.horario);
    setNuevaCita(true);

    var nuevaFec = new Date(props.fecha);
    setNuevaFecha(nuevaFec);
    setNuevaCita(props.nuevaCita);
    setNuevoPac(false);

    if (props.idPac === 0 || props.opcion === "Reprog") {
      await getListaPacientes(idNegocio).then((res) => {
        setListaPacientes(res);
        setTelefono("");
        setOpenHor(true);
      });
    } else {
      await loadDatosCita(props.idPac, props.fecha);
    }
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const save = async () => {
    var data = {
      id: idNegocio,
      idServicio: idServicio,
      idMedico: idMedico,
      idPaciente: idPaciente,
      fecha: moment(selectedDate).format("YYYY-MM-DD"),
      hora: horaIni,
    };

    await saveCitaMedico(data).then((res) => {
      if (res.data > 0) {
        toast("Se actualizo la cita de forma correcta", "success");
        loadAgenda(idMedico);
        setOpenHor(false);
      } else {
      }
    });
  };

  const handleCancelCita = () => {
    setOpenCancel(true);
    setDataCancel(
      `Paciente: ${paciente} - Fecha: ${moment(fecha).format("DD-MM-YYYY")}`,
    );
  };

  const getTodoList = (date) => {
    const dataForDay = eventData.filter(
      (event) =>
        new Date(event.date).getDate() === date.getDate() &&
        new Date(event.date).getMonth() === date.getMonth() &&
        new Date(event.date).getFullYear() === date.getFullYear(),
    );
    return dataForDay;
  };

  const iniciarConsulta = () => {
    var fec = moment(fecha).format("YYYY-MM-DD");
    window.location.replace(
      `/#/App/Home/CitasMedicas/Consulta/${idPaciente}/${idServicio}/${fec}/${horaIni}`,
    );
  };

  const handleMonthChange = (date) => {
    // The 'date' parameter is a Date object representing the new month
    setCurrentMonth(moment(date).format("MM"));
    setMes(moment(date).format("MM"));
    setAnio(moment(date).format("YYYY"));
    // You can also access the year and month specifically:
    // const year = date.getFullYear();
    // const mon
    //
    //th = date.getMonth(); // 0-based index
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadServicios();
    }
  }, []);

  return (
    <>
      <title>Citas Médicas</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Citas (Médicas)" },
        ]}
        selectedKey={"2.2"}
      >
        <>
          {contextHolder}
          <HStack>
            <SelectPicker
              searchable={false}
              data={listServicios}
              value={idServicio}
              onChange={(e) => loadMedicos(e)}
              style={{ width: "30%" }}
              block
              placeholder="--SELECCIONA UN SERVICIO--"
            />
            <SelectPicker
              searchable={false}
              data={listMedicos}
              value={idMedico}
              style={{ width: "30%" }}
              onChange={(e) => setIdMedico(e)}
              block
              placeholder="--SELECCIONA UN MÉDICO--"
            />
            <Button
              type="primary"
              onClick={() => loadAgenda(idMedico)}
              icon={<FaSearch></FaSearch>}
            >
              Buscar
            </Button>
          </HStack>
          <Styles />
          <CustomProvider locale={es_ES}>
            <Calendar
              onMonthChange={handleMonthChange}
              bordered
              cellClassName={(date) =>
                date.getDay() % 2 ? "bg-gray" : undefined
              }
              onSelect={handleSelect}
              renderCell={(date) => {
                const list = getTodoList(date);
                if (list.length) {
                  return (
                    <div
                      style={{
                        overflowY: "scroll",
                        height: "70px",
                        overflowAnchor: "none",
                        whitespace: "nowrap",
                      }}
                      key={`${String(new Date(date)) + Math.floor(Math.random() * 10000)}`}
                    >
                      {list.map((item, index) => (
                        <li
                          key={`li-${item}-${index}`}
                          style={{
                            fontSize: "11px",
                            textAlign: "left",
                          }}
                        >
                          <Badge key={`badge-${index}`} color={item.tipo} />{" "}
                          <Button
                            type="text"
                            key={`button-${index}`}
                            size="sm"
                            style={{ fontSize: "14px" }}
                            onClick={async () =>
                              handleNewCita({
                                idPac: item.idPac,
                                fecha: item.date,
                                horario: item.horario,
                                paciente: item.paciente,
                                estatus: item.tipo,
                                opcion: "horarioDisp",
                              })
                            }
                          >
                            {/* <Whisper
                                  key={`whisper-${index}`}
                                  id={`wh-${item.idPac}-${item.date}-${item.horario}`}
                                  followCursor
                                  speaker={
                                    <Popover
                                      key={`popover-${index}`}
                                    >{`${item.paciente} / Cita: ${item.horario}`}</Popover>
                                  }
                                > */}
                            {item.horario} -{" "}
                            {item.paciente.length > 14
                              ? `${item.paciente.substring(0, 14)}...`
                              : item.paciente}
                            {/* </Whisper> */}
                          </Button>
                        </li>
                      ))}
                    </div>
                  );
                }
                return false;
              }}
            />
          </CustomProvider>
          {eventData.length === 0 ? (
            <center>
              <p style={{ color: "red", fontSize: "16px" }}>
                **** No se encontrarón citas ****
              </p>
            </center>
          ) : (
            <>
              <Panel
                collapsible
                bordered
                header={`Citas programadas: ${eventData.filter((event) => event.tipo === filtroCitas).length}`}
              >
                <div className="row mb-2">
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    <SelectPicker
                      data={dataFiltros}
                      value={filtroCitas}
                      onChange={(e) => {
                        loadCitasProgramadas(idMedico, e);
                        setFiltroCitas(e);
                      }}
                      block
                      placeholder="Filtrar por Estatus..."
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <Table
                    bordered
                    rowKey={(record) => record.idPac}
                    columns={columns}
                    dataSource={data}
                    pagination={{ pageSize: 1000 }}
                    scroll={{ y: 55 * 5 }}
                  />
                </div>
              </Panel>
            </>
          )}

          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE CANCELACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          <Modal
            open={openCancel}
            onClose={handleCloseCancel}
            backdrop="static"
            overflow="false"
          >
            <Modal.Header>
              <Modal.Title style={{ fontSize: "16px" }}>
                {dataCancel}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Panel bordered>
                <div className="row">
                  <div className="col">
                    <b>Motivo</b>
                    <Textarea
                      as="textarea"
                      rows={4}
                      placeholder="Escriba el motivo de la cancelación de la cita."
                      onChange={(e) => setMotivoCancel(e)}
                      disabled={btnCancel}
                    />
                  </div>
                </div>
              </Panel>
            </Modal.Body>
            <Modal.Footer>
              <Button
                danger
                icon={<FaTrash></FaTrash>}
                onClick={cancelarCita}
                disabled={motivoCancel.length > 0 ? false : true}
                type="primary"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleCloseCancel}
                type="primary"
                icon={<FaBackward></FaBackward>}
              >
                Regresar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO Y NUEVA CITA O RE-PROG <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          <Modal
            size="lg"
            open={openHor}
            onClose={handleCloseHorario}
            backdrop="static"
            overflow="false"
          >
            <Modal.Header>
              <Modal.Title>Cita: {dataEdit}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Panel bordered>
                <div className="row mb-3">
                  <div className="col-lg-8 col-md-8 col-sm-8">
                    <Text size={"sm"} weight="semibold">
                      Nombre
                    </Text>
                    {!nuevoPac ? (
                      <SelectPicker
                        width={"100%"}
                        data={listaPacientes}
                        value={idPaciente}
                        onChange={(e) => hanldeNombrePaciente(e)}
                        searchable
                        placeholder="Selecciona un paciente..."
                        block
                      ></SelectPicker>
                    ) : (
                      <Input readOnly value={paciente} />
                    )}
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Text size={"md"} weight="semibold">
                      Teléfono
                    </Text>
                    <Input
                      controls={false}
                      value={telefono}
                      maxLength={10}
                      min={0}
                      style={{ textAlign: "center" }}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Text size={"md"} weight="semibold">
                      Fecha de la cita
                    </Text>
                    <Input
                      readOnly
                      value={moment(selectedDate)
                        .format("dddd, DD MMMM YYYY")
                        .toUpperCase()}
                      style={{ backgroundColor: "#E7F8FE", fontWeight: "600" }}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <b>Horario</b>
                    <Input
                      placeholder="00:00"
                      maxLength={5}
                      value={horaIni}
                      readOnly={true}
                      style={{
                        textAlign: "center",
                        backgroundColor: "#E7F8FE",
                        fontWeight: "600",
                      }}
                    />
                  </div>
                </div>
              </Panel>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={handleCloseHorario}
                icon={<FaBackward></FaBackward>}
                type="primary"
              >
                Regresar
              </Button>
              <Button
                onClick={save}
                type="primary"
                disabled={Number(idPaciente) > 0 ? false : true}
                icon={<FaSave></FaSave>}
              >
                Guardar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> DRAWER DATOS DEL PACIENTE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
          <Drawer
            size={"md"}
            placement={"right"}
            open={modalDatosPac}
            onClose={() => setModalDatosPac(false)}
          >
            <Drawer.Header>
              <Drawer.Title>Datos de la Cita</Drawer.Title>
              <Drawer.Actions>
                <Button
                  icon={<FaDoorOpen></FaDoorOpen>}
                  onClick={() => setModalDatosPac(false)}
                  type="primary"
                >
                  Cerrar
                </Button>
              </Drawer.Actions>
            </Drawer.Header>
            <Drawer.Body>
              <Card title={paciente}>
                <Card.Grid style={{ width: "15%", textAlign: "left" }}>
                  <Text weight="semibold">Fecha Nacimiento</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "20%" }}>{fecNac}</Card.Grid>
                <Card.Grid style={{ width: "15%" }}>
                  <Text weight="semibold">Edad</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "50%" }}>{edad} años</Card.Grid>

                <Card.Grid style={{ width: "15%", textAlign: "center" }}>
                  <Text weight="semibold">Atención</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "20%" }}>
                  <Text>{atencion}</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "15%", textAlign: "center" }}>
                  <Text weight="semibold">Cita</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "50%" }}>
                  {moment(selectedDate).format("dddd, DD MMMM YYYY")}
                  &nbsp; <b>Horario</b>: &nbsp;
                  {horaIni}
                </Card.Grid>
                <Card.Grid style={{ width: "15%" }}>
                  <Text weight="semibold">Teléfono</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "20%" }}>
                  <Text>{telefono}</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "15%", textAlign: "center" }}>
                  <Text weight="semibold">Contacto</Text>
                </Card.Grid>
                <Card.Grid style={{ width: "50%" }}>
                  <Highlight
                    query={["Nombre:", "Teléfono:", "Parentesco:"]}
                    style={{ fontSize: "14px" }}
                  >
                    <Text>
                      Nombre: {contacto1} <br></br> Teléfono: {tel1}
                    </Text>
                  </Highlight>
                  <Highlight query={"Parentesco:"}>
                    <Text> Parentesco: {parentesco1}</Text>
                  </Highlight>
                </Card.Grid>
                <Card.Grid style={{ width: "100%", textAlign: "center" }}>
                  <Text weight="semibold">
                    Estatus de la cita:{" "}
                    {estatusCita === "blue" ? (
                      <Tag color="blue">Realizada</Tag>
                    ) : estatusCita === "red" ? (
                      <Tag color="orange">Pendiente</Tag>
                    ) : (
                      <Tag color="green">Disponible</Tag>
                    )}
                  </Text>
                </Card.Grid>
              </Card>
              <br></br>
              <HStack>
                <Button
                  icon={<FaCheck></FaCheck>}
                  type="primary"
                  block
                  disabled={
                    estatusCita === "blue" || idMedicoSesion === 0
                      ? true
                      : false
                  }
                  onClick={() => iniciarConsulta()}
                >
                  Iniciar consulta
                </Button>
              </HStack>
              <br></br>
              <HStack>
                <Button
                  danger
                  type="primary"
                  icon={<FaTrash></FaTrash>}
                  block
                  onClick={() => handleCancelCita()}
                  disabled={estatusCita === "blue" ? true : false}
                >
                  Cancelar cita
                </Button>
              </HStack>
              <br></br>
            </Drawer.Body>
          </Drawer>
        </>
      </LayoutHome>
    </>
  );
};

const Styles = () => {
  return (
    <style>{`.bg-gray { background-color: rgba(242, 242, 242, 0.3);}`}</style>
  );
};
